import reducer from './reducers';
import * as jenkinsActions from './actions';

export { jenkinsActions };
export default reducer;
